// src/reducers/upReducers.js
import {
  GET_ALL_UP_RECORDS_REQUEST,
  GET_ALL_UP_RECORDS_SUCCESS,
  GET_ALL_UP_RECORDS_FAIL,
  GET_ALL_UP_RECORDS_RESET,

  IMPORT_UP_RECORDS_REQUEST,
  IMPORT_UP_RECORDS_SUCCESS,
  IMPORT_UP_RECORDS_FAIL,
  IMPORT_UP_RECORDS_RESET,

  EXPORT_UP_RECORDS_REQUEST,
  EXPORT_UP_RECORDS_SUCCESS,
  EXPORT_UP_RECORDS_FAIL,
  EXPORT_UP_RECORDS_RESET,

  UPDATE_UP_RECORD_REQUEST,
  UPDATE_UP_RECORD_SUCCESS,
  UPDATE_UP_RECORD_FAIL,
  UPDATE_UP_RECORD_RESET,

  DELETE_UP_RECORD_REQUEST,
  DELETE_UP_RECORD_SUCCESS,
  DELETE_UP_RECORD_FAIL,
  DELETE_UP_RECORD_RESET,

  BULK_DELETE_UP_RECORDS_REQUEST,
  BULK_DELETE_UP_RECORDS_SUCCESS,
  BULK_DELETE_UP_RECORDS_FAIL,
  BULK_DELETE_UP_RECORDS_RESET,
} from '../constants/upConstants';

// Get All UP Records Reducer
export const getAllUpRecordsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ALL_UP_RECORDS_REQUEST:
      return { loadingGetAllUpRecords: true };
    case GET_ALL_UP_RECORDS_SUCCESS:
      return {
        loadingGetAllUpRecords: false,
        getAllUpRecordsData: action.payload,
      };
    case GET_ALL_UP_RECORDS_FAIL:
      return {
        loadingGetAllUpRecords: false,
        errorGetAllUpRecords: action.payload,
      };
    case GET_ALL_UP_RECORDS_RESET:
      return {};
    default:
      return state;
  }
};

// Import UP Records Reducer
export const importUpRecordsReducer = (state = {}, action) => {
  switch (action.type) {
    case IMPORT_UP_RECORDS_REQUEST:
      return { loadingImportUpRecords: true };
    case IMPORT_UP_RECORDS_SUCCESS:
      return {
        loadingImportUpRecords: false,
        importUpRecordsData: action.payload,
      };
    case IMPORT_UP_RECORDS_FAIL:
      return {
        loadingImportUpRecords: false,
        errorImportUpRecords: action.payload,
      };
    case IMPORT_UP_RECORDS_RESET:
      return {};
    default:
      return state;
  }
};

// Export UP Records Reducer
export const exportUpRecordsReducer = (state = {}, action) => {
  switch (action.type) {
    case EXPORT_UP_RECORDS_REQUEST:
      return { loadingExportUpRecords: true };
    case EXPORT_UP_RECORDS_SUCCESS:
      return {
        loadingExportUpRecords: false,
        exportUpRecordsData: action.payload,
      };
    case EXPORT_UP_RECORDS_FAIL:
      return {
        loadingExportUpRecords: false,
        errorExportUpRecords: action.payload,
      };
    case EXPORT_UP_RECORDS_RESET:
      return {};
    default:
      return state;
  }
};


// Update UP Record Reducer
export const updateUpRecordReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_UP_RECORD_REQUEST:
      return { loadingUpdateUpRecord: true };
    case UPDATE_UP_RECORD_SUCCESS:
      return {
        loadingUpdateUpRecord: false,
        updateUpRecordData: action.payload,
      };
    case UPDATE_UP_RECORD_FAIL:
      return {
        loadingUpdateUpRecord: false,
        errorUpdateUpRecord: action.payload,
      };
    case UPDATE_UP_RECORD_RESET:
      return {};
    default:
      return state;
  }
};



// Delete UP Record Reducer
export const deleteUpRecordReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_UP_RECORD_REQUEST:
      return { loading: true };
    case DELETE_UP_RECORD_SUCCESS:
      return { loading: false, success: true };
    case DELETE_UP_RECORD_FAIL:
      return { loading: false, error: action.payload };
    case DELETE_UP_RECORD_RESET:
      return {};
    default:
      return state;
  }
};

// Bulk Delete UP Records Reducer
export const bulkDeleteUpRecordsReducer = (state = {}, action) => {
  switch (action.type) {
    case BULK_DELETE_UP_RECORDS_REQUEST:
      return { loadingBulkDeleteUpRecords: true };
    case BULK_DELETE_UP_RECORDS_SUCCESS:
      return {
        loadingBulkDeleteUpRecords: false,
        bulkDeleteUpRecordsData: action.payload,
      };
    case BULK_DELETE_UP_RECORDS_FAIL:
      return {
        loadingBulkDeleteUpRecords: false,
        errorBulkDeleteUpRecords: action.payload,
      };
    case BULK_DELETE_UP_RECORDS_RESET:
      return {};
    default:
      return state;
  }
};
